import React, { Component, ErrorInfo } from 'react';
import { ErrorPage } from './error-page';

interface Props {
  onError?: () => void;
  renderError: () => React.ReactNode;
}

interface State {
  error?: Error;
}

const Sentry: typeof import('@sentry/browser') | undefined = (window as any).Sentry;

export class ErrorBoundary extends Component<Props, State> {
  public static defaultProps: Props = {
    renderError: () => <ErrorPage />
  };

  public state: State = {};

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error });

    Sentry?.withScope(scope => {
      scope.setExtras({ errorInfo });
      Sentry?.captureException(error);
    });

    if (this.props.onError) {
      this.props.onError();
    }
  }

  public render() {
    return this.state.error ? this.props.renderError() : this.props.children;
  }
}
